<template >
  <base-dialog-form ref="gestAffiliazioneDialog" :title="computedTitle" :text="affiliazione" color="secondary"
    icon="mdi-handshake-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveAffiliazione" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT' && affiliazione !== ''" @click="deleteAffiliazione" color="error">{{
            $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-container>
      <form>
        <v-row>
          <v-col md="2" cols="6">
            <v-text-field :disabled="method !== 'ADD'" v-model="affiliazioneData.affiliazione" :label="$t('code')"
              hide-details="auto" :rules="required"></v-text-field>
          </v-col>
          <v-col md="1" cols="6">
            <v-checkbox :disabled="method === 'VIEW'" v-model="affiliazioneData.status"
              :label="$t('active_f_s')"></v-checkbox>
          </v-col>
          <v-col md="2" cols="6">
            <v-switch :disabled="method === 'VIEW'" v-model="affiliazioneData.buyWithCredits" :false-value="0"
              :true-value="1" :label="$t('can_buy_with_credits')"></v-switch>
          </v-col>
          <v-col md="2" cols="6">
            <v-text-field :disabled="method === 'VIEW'" v-model="affiliazioneData.prezzo" :label="$t('price')"
              hide-details="auto" :rules="required"></v-text-field></v-col>
          <v-col md="5" cols="12">
            <v-text-field :disabled="method === 'VIEW'" v-model="affiliazioneData.descr" :label="$t('description')"
              :rules="required" hide-details="auto"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-simple-table>
              <tbody>
                <tr v-for="tessera in affiliazioneData.tessere" v-bind:key="tessera.tesId">
                  <td>
                    <v-checkbox :disabled="method === 'VIEW'" v-model="tessera.status"
                      :label="$t('active_f_s')"></v-checkbox>
                  </td>
                  <td>
                    <img style="height: 50px" :src="tessera.imgTessera" />
                  </td>
                  <td>
                    <h3 :style="'color: ' + tessera.hexColor + ';'">
                      {{ tessera.nome }}
                    </h3>
                  </td>
                  <td>
                    <h3 :style="'color: ' + tessera.hexColor + ';'">
                      {{ tessera.prezzo }}
                    </h3>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </form>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";

export default {
  name: "gest-affiliazione",
  data() {
    return {
      affiliazione: null,
      method: null,
      affiliazioneData: {},
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, affiliazione) {
      this.method = method;
      this.affiliazione = affiliazione;
      this.loadData();
      this.$refs.gestAffiliazioneDialog.open();
    },
    loadData() {
      let _ = this;
      _.affiliazioneData = {};
      _.chiamataAxios(
        "GET",
        "/auth/ente/getAffiliazione/" + _.affiliazione
      ).then((response) => {
        _.affiliazioneData = response.data;
        _.affiliazioneData.buyWithCredits = Number(_.affiliazioneData.buyWithCredits) === 1 ? 1 : 0;
        if (_.method === "COPY") {
          _.affiliazione = null;
          _.affiliazioneData.affiliazione = null;
          _.method = "ADD";
        }
      });
    },
    deleteAffiliazione(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/ente/deleteAffiliazione/" + _.affiliazione,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.severity > 0) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.$emit("isUpdated", "true");
              _.$refs.gestAffiliazioneDialog.close();
            }
          });
        }
      });
    },
    saveAffiliazione: function () {
      let _ = this;
      let url = "/auth/ente/saveAffiliazione";
      let method = "PUT";
      let saveAffiliazione = _.affiliazioneData;
      saveAffiliazione.buyWithCredits = Number(saveAffiliazione.buyWithCredits) === 1 ? 1 : 0;
      saveAffiliazione.tessere = saveAffiliazione.tessere
        .filter((tessera) => {
          return tessera.status;
        })
        .map((tessera) => {
          return tessera.tesId;
        });
      _.chiamataAxios(method, url, {
        dialogLoader: true,
        body: saveAffiliazione,
      }).then((response) => {
        let html = "<strong>" + response.msg.msgTxt + "</strong>"
        if (response.msg.severity > 0)
          html = "<strong>" + response.msg.msgTxt + "</strong>";
        Swal.fire({
          type: "success",
          html: html,
        });
        _.$emit("isUpdated", "true");
        _.$refs.gestAffiliazioneDialog.close();
      });
    },
  },

  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_affiliation_type");
      else if (this.method === "VIEW") return this.$t("view_affiliation_type");
      else if (this.method === "ADD") return this.$t("create_affiliation_type");
      else if (this.method === "DELETE")
        return this.$t("delete_affiliation_type");
      else return "";
    },
  },
};
</script>
